import { post, get } from '../axios'

// 启用导航
export function nav_active_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/active`, map, option).then(
    response => response
  )
}

// collection列表
export function nav_col_list_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/col/list`, map, option).then(
    response => response
  )
}

// 删除导航
export function nav_delete_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_NAV}/nav/delete/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 导航详情
export function nav_detail_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_NAV}/nav/detail/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 查询导航
export function nav_get_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/get`, map, option).then(
    response => response
  )
}

// 导航列表
export function nav_list_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/list`, map, option).then(
    response => response
  )
}

// 查询导航菜单配置
export function nav_query_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/query`, map, option).then(
    response => response
  )
}

// 保存导航
export function nav_save_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/save`, map, option).then(
    response => response
  )
}

// 查询赛马开关
export function nav_race_switch_query_get(map, option) {
  return get(
    `${process.env.VUE_APP_NAV}/nav/race/switch/query`,
    map,
    option
  ).then(response => response)
}

// 保存赛马开关
export function nav_race_switch_save_post(map, option) {
  return post(
    `${process.env.VUE_APP_NAV}/nav/race/switch/save`,
    map,
    option
  ).then(response => response)
}

// 测试导航赛马排序
export function nav_race_query_test_get(map, option) {
  return get(
    `${process.env.VUE_APP_NAV}/nav/race/query/test`,
    map,
    option
  ).then(response => response)
}

// 初始同步菜单表数据到日志表里
export function nav_sync_get(map, option) {
  return get(`${process.env.VUE_APP_NAV}/nav/sync`, map, option).then(
    response => response
  )
}

// 复制导航
export function nav_copy_id_get(map, option) {
  return get(`${process.env.VUE_APP_NAV}/nav/copy/${map.id}`, map, option).then(
    response => response
  )
}
